// extracted by mini-css-extract-plugin
module.exports =  {"modalWidth":"740px","modal":"modal--TUCZs","input-param":"input-param--uQn_R","inputParam":"input-param--uQn_R"};